import { Divider as MuiDivider, DividerProps, styled } from "@mui/material";

const Divider = styled(MuiDivider)<DividerProps>(({ theme }) => ({
  borderColor: theme?.palette?.custom?.border?.inactive,
}));

export default Divider;
